import "./App.css";
import { ToastContainer } from "react-toastify";
import Router from "./router/router";
import { useEffect } from "react";
import { onAuthStateChanged } from "@firebase/auth";
import { auth } from "./firebase";

function App() {
  const refreshToken = async (user: any) => {
    try {
      const token = await user.getIdToken(true);
      localStorage.setItem("accessToken", token);
    } catch (error) {
      console.error("Token refresh failed:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        refreshToken(user);
      } else {
        
      }
    });

    return () => unsubscribe();
  }, []);
  return (
    <>
      <Router />
      <ToastContainer />
    </>
  );
}

export default App;
